import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { WhatsappLogo, InstagramLogo, Star, MapPin, Phone, List, X, CaretDown, Clock, ArrowRight } from "@phosphor-icons/react";
import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// WhatsApp Link
const WHATSAPP_URL = "https://api.whatsapp.com/send/?phone=491731521789&text&type=phone_number&app_absent=0";

// Assets
const LOGO_URL = "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/wwpgwrnh_Kryptonite%20Logo.png";
const VIDEO_URL = "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/1yipm7s1_logo%20%285%29.mp4";

// Team data - 4 Artists
const teamMembers = [
  { name: "Csaba", image: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/tqwk7apx_Csaba.png", instagram: "https://www.instagram.com/hellosztok/" },
  { name: "Attila", image: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/o6easw8i_Attila.png", instagram: "https://www.instagram.com/attes_tattoo/" },
  { name: "Patrycja", image: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/bfd9xi9a_Patrycja.png", instagram: "https://www.instagram.com/pajak.tattoo/" },
  { name: "Anna", image: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/u5t48d7l_Anna.png", instagram: "https://www.instagram.com/annastella_tattoo/" },
];

// Gallery images with artist attribution - shuffled for variety
const galleryImages = [
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/phe8bb9h_Csaba_01.JPEG", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/oiqh8zeh_Anna_01-2026-01-28-18-14-12%204.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/n9tsk8sa_Attila_01.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/hbwpqhq8_Paty_01.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/fw20jan9_Csaba_02.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/n7jz2sha_Anna_01-2026-01-28-18-14-12%207.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/qygas08n_Attila_02.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/mr4j2kjr_Paty_02.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/sy726hz2_Csaba_03.JPG", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/ox4idf3s_Anna_01-2026-01-28-18-14-12%208.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/i3uac5z1_Attila_06.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/tvp965l7_Paty_03.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/uiybzc0k_Csaba_04.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/z2x31zbq_Anna_01-2026-01-28-18-14-12%209.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/xsu0tqtg_Attila_08.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/w4ju1b7n_Paty_04.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/rj06uuu3_Csaba_05.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/95n2wk11_Anna_01-2026-01-28-18-14-12.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/emz9tgc9_Attila_10.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/bdz5gvi8_verwendet%2012.02..jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/x6mvze1k_Csaba_06.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/whnjka35_Anna_01-2026-01-28-18-14-12%209.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/qmro20c7_Attila_12.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/qj6al18v_Paty_07.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/2uqtqjdd_Csaba_07.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/ezqm4mds_Anna_01-2026-01-28-18-14-12.jpg", artist: "Anna" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/y059xp8z_Attila_15.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/ktv7flzj_PHOTO-2026-01-13-00-12-32%208.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/j0nto9go_Csaba_08.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/h7p6nbho_IMG_2398.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/rngmt5ag_PHOTO-2026-01-13-00-12-32%2010.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/08v6vu04_Csaba_09.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/3hpztwhf_IMG_2411.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/sg0wv2qc_PHOTO-2026-01-13-00-12-32%2011.jpg", artist: "Patrycja" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/jr8w2j13_IMG_8477.png", artist: "Csaba" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/xe6gli2s_IMG_2419.png", artist: "Attila" },
  { url: "https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/qzyhbo89_PHOTO-2026-01-13-00-12-33.jpg", artist: "Patrycja" },
];

// Reviews data
const reviews = [
  { name: "Hannah", text: "Habe hier ein tolles Tattoo gestochen bekommen. Mega filigran. Bin super zufrieden, würde fürs nächste auf jeden Fall wieder kommen! Danke für den guten Service." },
  { name: "Alex", text: "Super Studio! Absolute Familien Behandlung und verdammt gute Tattos!!! Kann ich nur weiter empfehlen! Danke auch für die Super Beratung!!!" },
  { name: "Julia", text: "Wunderschönes Studio mit total nettem Personal. Tattoos werden sauber gestochen. Ich komme immer wieder gern zu euch!" },
  { name: "Jasmin", text: "Vor 2 Tagen habe ich mir beim lieben Kryptonite-Team ein Tattoo stechen lassen. Ich wurde sehr herzlich empfangen, man fühlt sich sofort wohl." },
  { name: "Andreas", text: "Kleines Tattoo Studio mit voll netten Leuten habe mein Cover up da machen lassen und bin super zufrieden nächstes tattoo lasse ich da auch machen" },
  { name: "Vivien", text: "Ich habe mir hier meine ersten Tattoos stechen lassen und bin begeistert wie fein und sauber gearbeitet wurde. Das Team ist super freundlich und kompetent." },
  { name: "Nikita", text: "Meine Frau und ich waren heute in dem Tattoostudio und waren sehr erfreut über die freundlichen Mitarbeiter. Künstlerisch einfach der Hammer!" },
  { name: "Roland", text: "Habe mir gestern von Csaba ein Tattoo stechen lassen, nachdem ich bereits beim Vorgespräch wirklich von dem Studio begeistert war. Die Atmosphäre ist ganz toll und gemütlich." },
  { name: "Steven", text: "I went in with a very clear design. Csaba was very professional, easy to communicate with and a talented artist. He had no issue making sure everything was perfect." },
];

// FAQ data - organized by category
const faqCategories = [
  {
    category: "Termin & Beratung",
    faqs: [
      { question: "Wie kann ich einen Termin vereinbaren?", answer: "Per WhatsApp mit deiner Motividee, der Körperstelle (Foto) und Wunschtermin. Somit haben wir schonmal eine gute Basis und wir können dir den Artist empfehlen, der am besten zu deinem Projekt passt." },
      { question: "Ist die Beratung kostenlos?", answer: "Ja, komplett kostenfrei – einfach per WhatsApp schreiben und wir vereinbaren einen Termin." },
      { question: "Wie lange muss ich auf einen Tattoo-Termin warten?", answer: "Je nach Artist und Aufwand, meist innerhalb weniger Wochen möglich." },
      { question: "Kann ich auch ohne Termin vorbeikommen?", answer: "Für Beratung ja, für Tattoos nur mit Termin." },
    ]
  },
  {
    category: "Kosten & Preise",
    faqs: [
      { question: "Was kostet ein Tattoo?", answer: "Abhängig von Größe, Detailgrad, Körperstelle und Zeitaufwand – das muss individuell besprochen werden." },
      { question: "Gibt es einen Mindestpreis?", answer: "Ja, durch Grundaufwand für Material und Vorbereitung." },
    ]
  },
  {
    category: "Vorbereitung",
    faqs: [
      { question: "Wie bereite ich mich auf meinen Termin vor?", answer: "Ausgeschlafen, gut gegessen, kein Alkohol, Stelle rasiert, nicht eingecremt." },
      { question: "Ab welchem Alter kann ich mich tätowieren lassen?", answer: "Mindestens 18 Jahre – Ausnahmen unter 18 Jahre nur im Beisein der Eltern (keine Zettel)." },
      { question: "Kann ich mich bei Krankheit tätowieren lassen?", answer: "Nein, bitte absagen – bei Erkältung, Fieber oder Hautproblemen ist kein Tattoo möglich." },
    ]
  },
  {
    category: "Das Tattoo selbst",
    faqs: [
      { question: "Kann ich mein eigenes Motiv mitbringen?", answer: "Ja, gerne! Bilder, Skizzen oder Beschreibungen helfen bei der Umsetzung." },
      { question: "Kann man über Narben tätowieren?", answer: "Meist ja, wenn die Narbe gut verheilt ist (mind. 1 Jahr alt)." },
      { question: "Macht ihr auch Fineline-Tattoos?", answer: "Ja, wir achten dabei auf Linienstärken, die auch langfristig schön bleiben." },
      { question: "Gibt es Körperstellen, die ihr nicht tätowiert?", answer: "Gesicht, Hals und Hände nur nach ausführlicher Beratung." },
    ]
  },
  {
    category: "Nachsorge & Heilung",
    faqs: [
      { question: "Wie pflege ich mein frisches Tattoo?", answer: "Sauber halten, 3-6x täglich eincremen, nicht kratzen, Sonne meiden." },
      { question: "Wann kann ich wieder Sport machen?", answer: "Idealerweise 2 Wochen warten." },
      { question: "Wann darf ich wieder schwimmen gehen?", answer: "Nach vollständiger Heilung (ca. 3-5 Wochen)." },
      { question: "Sollte ich direkt vor dem Urlaub ein Tattoo machen?", answer: "Besser nicht – Sonne und Wasser sollten gemieden werden." },
    ]
  },
  {
    category: "Cover-Up & Korrekturen",
    faqs: [
      { question: "Kann ich ein altes Tattoo überdecken lassen?", answer: "Ja, Cover-Ups sind möglich – das neue Motiv muss meist doppelt so groß und dunkler sein." },
      { question: "Was ist ein Touch-Up?", answer: "Nachstechen von verblassten Stellen nach vollständiger Heilung." },
    ]
  },
];

// Navigation Component with Scroll Spy
const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
      
      // Scroll Spy - detect active section
      const sections = ['studio', 'team', 'galerie', 'bewertungen', 'faqs', 'kontakt'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150 && rect.bottom >= 150) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { name: "Studio", href: "#studio", id: "studio" },
    { name: "Team", href: "#team", id: "team" },
    { name: "Galerie", href: "#galerie", id: "galerie" },
    { name: "Bewertungen", href: "#bewertungen", id: "bewertungen" },
    { name: "FAQs", href: "#faqs", id: "faqs" },
    { name: "Kontakt", href: "#kontakt", id: "kontakt" },
  ];

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-[#050505]/90 nav-blur border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#" data-testid="nav-logo" className="flex items-center">
            <img src={LOGO_URL} alt="Tattoo Kryptonite" className="h-12 w-auto invert" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                data-testid={`nav-link-${link.name.toLowerCase()}`}
                className={`nav-link text-sm font-medium transition-colors tracking-wide uppercase ${
                  activeSection === link.id ? "text-white" : "text-[#A0A0A0] hover:text-white"
                }`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-button"
            className="md:hidden text-white p-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menü öffnen"
          >
            {mobileMenuOpen ? <X size={28} weight="light" /> : <List size={28} weight="light" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`mobile-menu md:hidden fixed top-20 right-0 bottom-0 w-full bg-[#050505] border-l border-white/10 ${
          mobileMenuOpen ? "open" : ""
        }`}
      >
        <div className="p-6 space-y-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              data-testid={`mobile-nav-link-${link.name.toLowerCase()}`}
              className={`block text-2xl font-serif transition-colors ${
                activeSection === link.id ? "text-white" : "text-[#A0A0A0] hover:text-white"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </a>
          ))}
          {/* Mobile WhatsApp Button */}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 mt-8 justify-center"
          >
            <WhatsappLogo size={20} weight="fill" />
            <span className="font-medium">Termin buchen</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

// Hero Section
const HeroSection = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  
  return (
    <section data-testid="hero-section" className="relative h-screen flex items-center justify-center overflow-hidden bg-[#050505]">
      {/* Fallback Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0"
        style={{ 
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/xdqqr89p_Foto%2013.01.19%2C%2012%2058%2026.jpg')`,
          filter: 'brightness(0.3)'
        }}
      />
      
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        onLoadedData={() => setVideoLoaded(true)}
        className={`video-background transition-opacity duration-1000 ${videoLoaded ? 'opacity-100' : 'opacity-0'}`}
      >
        <source src={VIDEO_URL} type="video/mp4" />
      </video>
      <div className="video-overlay" />

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <p className="hero-animate text-xs md:text-sm uppercase tracking-[0.3em] text-white/50 mb-6">
          Weißgerbergraben 6, 93047 Regensburg
        </p>
        <h1 className="hero-animate hero-animate-delay-1 font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-6 tracking-tight">
          Tattoo Kryptonite
        </h1>
        <p className="hero-animate hero-animate-delay-2 text-lg md:text-xl text-[#A0A0A0] mb-6 max-w-xl mx-auto">
          Motive die unter die Haut gehen
        </p>
        
        {/* Google Rating Badge */}
        <div className="hero-animate hero-animate-delay-2 flex items-center justify-center gap-2 mb-10">
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={16} weight="fill" className="text-yellow-400" />
            ))}
          </div>
          <span className="text-white font-medium">4.9</span>
          <span className="text-[#A0A0A0]">•</span>
          <span className="text-[#A0A0A0]">778 Bewertungen auf Google</span>
        </div>
        
        <div className="hero-animate hero-animate-delay-3 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#studio"
            data-testid="hero-cta"
            className="inline-flex items-center gap-2 border border-white/30 px-8 py-4 text-sm uppercase tracking-widest text-white hover:bg-white hover:text-[#050505] transition-all duration-300"
          >
            Studio entdecken
            <ArrowRight size={18} weight="light" />
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-whatsapp-btn"
            className="inline-flex items-center gap-2 bg-[#25D366] px-8 py-4 text-sm uppercase tracking-widest text-white hover:bg-[#20bd5a] transition-all duration-300"
          >
            <WhatsappLogo size={18} weight="fill" />
            Termin buchen
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10">
        <div className="w-px h-20 bg-gradient-to-b from-white/50 to-transparent" />
      </div>
    </section>
  );
};

// About Section
const AboutSection = () => {
  return (
    <section id="studio" data-testid="about-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Images Grid */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/xdqqr89p_Foto%2013.01.19%2C%2012%2058%2026.jpg"
                alt="Tattoo Kryptonite Studio"
                className="w-full aspect-[4/5] object-cover col-span-2"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/cjvlgc7z_Foto%2013.01.19%2C%2012%2059%2019.jpg"
                alt="Tattoo Kryptonite Studio Interior"
                className="w-full aspect-square object-cover"
              />
              <img
                src="https://customer-assets.emergentagent.com/job_design-showcase-738/artifacts/xjlctrv9_Foto%2016.02.19%2C%2012%2048%2054%20%282%29.jpg"
                alt="Tattoo Kryptonite Workspace"
                className="w-full aspect-square object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#121212] border border-white/10 p-6">
              <p className="text-xs uppercase tracking-[0.2em] text-white/50">Seit</p>
              <p className="text-4xl font-serif text-white">2015</p>
            </div>
          </div>

          {/* Text */}
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Unser Studio</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white mb-8 leading-tight">
              Unser Studio am Weißgerbergraben
            </h2>
            <div className="space-y-6 text-[#A0A0A0] leading-relaxed">
              <p>
                Bei uns erwartet dich keine angespannte Studio-Atmosphäre, sondern ein Ort, an dem du dich sofort wohlfühlst – fast wie im eigenen Wohnzimmer. Entspannt, persönlich und ohne Druck.
              </p>
              <p>
                Wir nehmen uns bewusst Zeit für dich und deine Ideen. Egal ob du schon ein konkretes Motiv hast oder noch ganz am Anfang stehst – wir beraten dich ehrlich, individuell und auf Augenhöhe. Ohne Hektik, ohne Fließband.
              </p>
              <p>
                Komm einfach vorbei, lerne uns kennen und verschaff dir selbst einen Eindruck.
              </p>
              <p className="text-white font-medium">
                Die Beratung ist bei uns selbstverständlich kostenlos.
              </p>
              <p className="text-white font-serif text-xl italic">
                Wir freuen uns auf dich.
              </p>
            </div>
            
            {/* Contact Info */}
            <div className="mt-10 p-6 bg-[#121212] border border-white/10">
              <p className="font-serif text-2xl text-white mb-4">Tattoo Kryptonite</p>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <MapPin size={20} weight="light" className="text-white" />
                  <span className="text-[#A0A0A0]">Weißgerbergraben 6</span>
                </div>
                <div className="flex items-center gap-3">
                  <Phone size={20} weight="light" className="text-white" />
                  <a href="tel:01731521789" className="text-[#A0A0A0] hover:text-white transition-colors">0173 152 1789</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Team Section
const TeamSection = () => {
  return (
    <section id="team" data-testid="team-section" className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Unser Team</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white">Team Kryptonite</h2>
        </div>

        {/* Team Description */}
        <div className="max-w-3xl mx-auto mb-16 space-y-6 text-[#A0A0A0] leading-relaxed">
          <p>
            Seit über 11 Jahren ist Tattoo Kryptonite am Weißgerbergraben nicht einfach nur ein Studio – es ist ein Ort, an dem Ideen zu echter, langlebiger Kunst werden. Hier geht es nicht um schnelle Tattoos von der Stange, sondern um individuelle Arbeiten, die zu dir passen und dich ein Leben lang begleiten.
          </p>
          
          <div>
            <p className="text-white font-medium mb-2">Was uns besonders macht? Unser Team.</p>
            <p>
              Jeder Artist bei Kryptonite bringt seinen eigenen Stil, seine eigene Handschrift und vor allem echte Leidenschaft mit. Egal ob Fineline, Black & Grey, Cover-ups oder farbintensive Motive – wir haben für jede Idee den richtigen Kopf und die ruhige Hand. Dabei arbeiten wir nicht nur sauber und professionell, sondern nehmen uns auch die Zeit, dich ehrlich zu beraten. Kein Ego, kein Druck – sondern Fokus auf das beste Ergebnis für dich.
            </p>
          </div>

          <div>
            <p className="text-white font-medium mb-2">Du willst sehen, wer hinter der Nadel steckt?</p>
            <p>
              Klick dich durch die Profile unserer Artists und schau dir ihre Arbeiten direkt auf Instagram an. So bekommst du sofort ein Gefühl dafür, wer zu deinem Stil passt.
            </p>
          </div>

          <p className="text-white text-center text-lg font-serif italic">
            Am Ende zählt für uns, dass du als Kunde 100% zufrieden bist.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {teamMembers.map((member, index) => (
            <a
              key={member.name}
              href={member.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`team-member-${member.name.toLowerCase()}`}
              className="team-card group relative aspect-[3/4] overflow-hidden"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <p className="text-white font-serif text-xl">{member.name}</p>
                <div className="flex items-center gap-2 text-white/60 text-sm mt-1">
                  <InstagramLogo size={16} weight="fill" />
                  <span>Instagram</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

// Gallery Section
const GallerySection = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [visibleRows, setVisibleRows] = useState(2); // Start with 2 rows (8 images on desktop)
  
  // Calculate images per row based on screen (4 on lg, 3 on md, 2 on mobile)
  const imagesPerRow = 4;
  const visibleImages = visibleRows * imagesPerRow;
  const hasMoreImages = visibleImages < galleryImages.length;

  const showMoreImages = () => {
    setVisibleRows(prev => prev + 1);
  };

  return (
    <section id="galerie" data-testid="gallery-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Unsere Arbeiten</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white">Tattoo Galerie</h2>
        </div>

        {/* Uniform Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {galleryImages.slice(0, visibleImages).map((image, index) => (
            <div
              key={index}
              data-testid={`gallery-item-${index}`}
              className="gallery-item relative aspect-square overflow-hidden bg-[#121212]"
              onClick={() => setSelectedImage(image.url)}
            >
              <img
                src={image.url}
                alt={`Tattoo von ${image.artist}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
              />
              {image.artist && (
                <span className="absolute bottom-2 right-2 text-xs text-gray-400 bg-black/60 px-2 py-1 backdrop-blur-sm">
                  {image.artist}
                </span>
              )}
            </div>
          ))}
        </div>

        {/* Show More Button */}
        {hasMoreImages && (
          <div className="flex justify-center mt-10">
            <button
              onClick={showMoreImages}
              data-testid="gallery-show-more"
              className="flex flex-col items-center gap-2 text-[#A0A0A0] hover:text-white transition-colors group"
            >
              <span className="text-sm uppercase tracking-widest">Mehr anzeigen</span>
              <CaretDown 
                size={32} 
                weight="light" 
                className="animate-bounce"
              />
            </button>
          </div>
        )}

        {/* Lightbox Dialog */}
        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent 
            data-testid="gallery-lightbox"
            className="max-w-4xl bg-transparent border-none shadow-none p-0"
          >
            <DialogTitle className="sr-only">Tattoo Bild Ansicht</DialogTitle>
            <DialogClose className="absolute top-4 right-4 z-10 bg-black/50 rounded-full p-2 text-white hover:bg-black/70 transition-colors">
              <X size={24} weight="light" />
            </DialogClose>
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Tattoo Detail"
                className="w-full h-auto max-h-[90vh] object-contain"
              />
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

// Reviews Section
const ReviewsSection = () => {
  return (
    <section id="bewertungen" data-testid="reviews-section" className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Kundenstimmen</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white mb-4">Das sagen unsere Kunden</h2>
          <div className="flex items-center justify-center gap-2 mb-2">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={24} weight="fill" className="star-filled" />
            ))}
          </div>
          <p className="text-[#A0A0A0]">
            <span className="text-white text-2xl font-serif">4.9</span> / 5 aus <span className="text-white">778</span> Bewertungen
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="marquee-container relative">
        <Marquee gradient={false} speed={40} pauseOnHover>
          {reviews.map((review, index) => (
            <div
              key={index}
              data-testid={`review-card-${index}`}
              className="review-card mx-3 w-[350px] p-6 flex-shrink-0"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={14} weight="fill" className="star-filled" />
                ))}
              </div>
              <p className="text-[#A0A0A0] text-sm leading-relaxed mb-4 line-clamp-4">
                "{review.text}"
              </p>
              <p className="text-white font-medium">{review.name}</p>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

// FAQ Section - Only first category on main page
const FAQSection = () => {
  const firstCategory = faqCategories[0]; // Only "Termin & Beratung"
  
  return (
    <section id="faqs" data-testid="faq-section" className="py-24 md:py-32 bg-[#050505]">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Häufige Fragen</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white">FAQs</h2>
          <p className="mt-4 text-[#A0A0A0]">Alles was du vor deinem Tattoo wissen solltest</p>
        </div>

        <div>
          <h3 className="text-lg font-medium text-white mb-6 pb-2 border-b border-white/20">
            {firstCategory.category}
          </h3>
          <Accordion type="single" collapsible className="space-y-2">
            {firstCategory.faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                data-testid={`faq-item-${index}`}
                className="border border-white/10 bg-[#0a0a0a] px-6"
              >
                <AccordionTrigger 
                  data-testid={`faq-trigger-${index}`}
                  className="text-left text-white hover:text-white/80 py-5 text-base"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#A0A0A0] pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Link to full FAQ page */}
        <div className="mt-12 text-center">
          <Link
            to="/faq"
            data-testid="faq-more-link"
            className="inline-flex items-center gap-2 border border-white/30 px-8 py-4 text-sm uppercase tracking-widest text-white hover:bg-white hover:text-[#050505] transition-all duration-300"
          >
            Alle FAQs ansehen
            <ArrowRight size={18} weight="light" />
          </Link>
        </div>
      </div>
    </section>
  );
};

// Location Section
const LocationSection = () => {
  return (
    <section id="kontakt" data-testid="location-section" className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Besuche uns</p>
          <h2 className="font-serif text-4xl md:text-5xl text-white">Standort</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Map */}
          <div className="aspect-square md:aspect-auto md:h-[500px] overflow-hidden">
            <iframe
              data-testid="google-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2618.8244548661387!2d12.093823!3d49.019444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479fc19f3d8a8c2d%3A0x8b5a5a5a5a5a5a5a!2sWei%C3%9Fgerbergraben%206%2C%2093047%20Regensburg!5e0!3m2!1sde!2sde!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="map-dark-mode"
              title="Tattoo Kryptonite Location"
            />
          </div>

          {/* Info */}
          <div className="flex flex-col justify-center space-y-8">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">Adresse</p>
              <p className="text-2xl font-serif text-white">Weißgerbergraben 6</p>
              <p className="text-2xl font-serif text-white">93047 Regensburg</p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">Telefon</p>
              <a href="tel:01731521789" className="text-2xl font-serif text-white hover:text-[#A0A0A0] transition-colors">
                0173 152 1789
              </a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">E-Mail</p>
              <a href="mailto:tattoo-kryptonite@gmx.de" className="text-xl font-serif text-white hover:text-[#A0A0A0] transition-colors">
                tattoo-kryptonite@gmx.de
              </a>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-2">Kontakt</p>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-whatsapp-btn"
                className="inline-flex items-center gap-3 bg-[#25D366] text-white px-6 py-3 hover:bg-[#20bd5a] transition-colors"
              >
                <WhatsappLogo size={24} weight="fill" />
                <span className="font-medium">WhatsApp schreiben</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Footer
const Footer = () => {
  return (
    <footer data-testid="footer" className="py-20 bg-[#050505] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="footer-text font-serif text-white opacity-10">KRYPTONITE</h2>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <Link to="/impressum" data-testid="footer-impressum" className="text-sm text-[#A0A0A0] hover:text-white transition-colors">
              Impressum
            </Link>
            <Link to="/dsgvo" data-testid="footer-dsgvo" className="text-sm text-[#A0A0A0] hover:text-white transition-colors">
              DSGVO
            </Link>
          </div>
          <p className="text-sm text-[#A0A0A0]">
            © {new Date().getFullYear()} Tattoo Kryptonite Regensburg
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="text-[#A0A0A0] hover:text-white transition-colors"
            >
              <InstagramLogo size={24} weight="fill" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

// WhatsApp Floating Button with Mobile CTA Bar
const WhatsAppButton = () => {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      // Show mobile CTA after scrolling past hero
      setShowMobileCTA(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  
  return (
    <>
      {/* Desktop Floating Button */}
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-floating-btn"
        className="hidden md:flex fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg shadow-[#25D366]/20 hover:scale-110 transition-transform whatsapp-pulse"
        aria-label="Kontakt via WhatsApp"
      >
        <WhatsappLogo size={28} weight="fill" />
      </a>
      
      {/* Mobile Sticky CTA Bar */}
      <div 
        className={`md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#050505]/95 backdrop-blur-sm border-t border-white/10 p-4 transition-transform duration-300 ${
          showMobileCTA ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-cta-btn"
          className="flex items-center justify-center gap-2 bg-[#25D366] text-white py-3 px-6 w-full font-medium"
        >
          <WhatsappLogo size={20} weight="fill" />
          Jetzt Termin anfragen
        </a>
      </div>
    </>
  );
};

// Home Page
const Home = () => {
  return (
    <>
      <Navigation />
      <HeroSection />
      <AboutSection />
      <TeamSection />
      <GallerySection />
      <ReviewsSection />
      <FAQSection />
      <LocationSection />
      <Footer />
      <WhatsAppButton />
    </>
  );
};

// Impressum Page
const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation />
      <div className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 className="font-serif text-4xl md:text-5xl text-white mb-12">Impressum</h1>
          <div className="prose prose-invert prose-lg max-w-none">
            <h2 className="font-serif text-2xl text-white mt-8 mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-[#A0A0A0]">
              Sophie Meyer<br />
              Weißgerbergraben 6<br />
              93047 Regensburg
            </p>

            <h3 className="font-serif text-xl text-white mt-8 mb-4">Vertreten durch:</h3>
            <p className="text-[#A0A0A0]">Christian Selch</p>

            <h3 className="font-serif text-xl text-white mt-8 mb-4">Kontakt:</h3>
            <p className="text-[#A0A0A0]">
              Telefon: 0173-1521789<br />
              E-Mail: tattoo-kryptonite@gmx.de
            </p>

            <h3 className="font-serif text-xl text-white mt-8 mb-4">Aufsichtsbehörde:</h3>
            <p className="text-[#A0A0A0]">Gewerbeamt Regensburg</p>

            <h2 className="font-serif text-2xl text-white mt-12 mb-4">Haftungsausschluss</h2>
            
            <h3 className="font-serif text-xl text-white mt-8 mb-4">Haftung für Links</h3>
            <p className="text-[#A0A0A0]">
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. 
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten 
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>

            <h3 className="font-serif text-xl text-white mt-8 mb-4">Urheberrecht</h3>
            <p className="text-[#A0A0A0]">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen 
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der 
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>
          <div className="mt-12">
            <Link to="/" className="text-[#A0A0A0] hover:text-white transition-colors">
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

// DSGVO Page
const DSGVOPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation />
      <div className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 className="font-serif text-4xl md:text-5xl text-white mb-12">Datenschutzerklärung</h1>
          <div className="prose prose-invert prose-lg max-w-none space-y-8">
            
            {/* Verantwortlicher */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Verantwortlicher</h2>
              <p className="text-[#A0A0A0]">
                Verantwortlicher im Sinne der Datenschutzgesetze, insbesondere der EU-Datenschutzgrundverordnung (DSGVO), ist:<br />
                <strong className="text-white">Christian Selch</strong>
              </p>
            </section>

            {/* Betroffenenrechte */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Ihre Betroffenenrechte</h2>
              <p className="text-[#A0A0A0] mb-4">
                Unter den angegebenen Kontaktdaten unseres Datenschutzbeauftragten können Sie jederzeit folgende Rechte ausüben:
              </p>
              <ul className="text-[#A0A0A0] list-disc pl-6 space-y-2">
                <li>Auskunft über Ihre bei uns gespeicherten Daten und deren Verarbeitung (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger personenbezogener Daten (Art. 16 DSGVO)</li>
                <li>Löschung Ihrer bei uns gespeicherten Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Datenverarbeitung, sofern wir Ihre Daten aufgrund gesetzlicher Pflichten noch nicht löschen dürfen (Art. 18 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung Ihrer Daten bei uns (Art. 21 DSGVO)</li>
                <li>Datenübertragbarkeit, sofern Sie in die Datenverarbeitung eingewilligt haben oder einen Vertrag mit uns abgeschlossen haben (Art. 20 DSGVO)</li>
              </ul>
              <p className="text-[#A0A0A0] mt-4">
                Sofern Sie uns eine Einwilligung erteilt haben, können Sie diese jederzeit mit Wirkung für die Zukunft widerrufen.
              </p>
              <p className="text-[#A0A0A0] mt-4">
                Sie können sich jederzeit mit einer Beschwerde an eine Aufsichtsbehörde wenden, z. B. an die zuständige Aufsichtsbehörde des Bundeslands Ihres Wohnsitzes oder an die für uns als verantwortliche Stelle zuständige Behörde.
              </p>
              <p className="text-[#A0A0A0] mt-4">
                Eine Liste der Aufsichtsbehörden (für den nichtöffentlichen Bereich) mit Anschrift finden Sie unter:{' '}
                <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">
                  www.bfdi.bund.de
                </a>
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Cookies</h2>
              <h3 className="font-serif text-xl text-white mb-2">Art und Zweck der Verarbeitung:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Wie viele andere Webseiten verwenden wir auch so genannte „Cookies". Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Webseite besuchen.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Hierdurch erhalten wir bestimmte Daten wie z. B. IP-Adresse, verwendeter Browser und Betriebssystem.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Cookies können nicht verwendet werden, um Programme zu starten oder Viren auf einen Computer zu übertragen. Anhand der in Cookies enthaltenen Informationen können wir Ihnen die Navigation erleichtern und die korrekte Anzeige unserer Webseiten ermöglichen.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                In keinem Fall werden die von uns erfassten Daten an Dritte weitergegeben oder ohne Ihre Einwilligung eine Verknüpfung mit personenbezogenen Daten hergestellt.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Natürlich können Sie unsere Website grundsätzlich auch ohne Cookies betrachten. Internet-Browser sind regelmäßig so eingestellt, dass sie Cookies akzeptieren. Im Allgemeinen können Sie die Verwendung von Cookies jederzeit über die Einstellungen Ihres Browsers deaktivieren.
              </p>
              <h3 className="font-serif text-xl text-white mt-6 mb-2">Browser-spezifische Anleitungen:</h3>
              <ul className="text-[#A0A0A0] list-disc pl-6 space-y-2">
                <li><a href="https://support.mozilla.org/de/kb/cookies-loeschen-daten-von-websites-entfernen" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Mozilla Firefox</a></li>
                <li><a href="https://support.microsoft.com/de-de/help/17442/windows-internet-explorer-delete-manage-cookies" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Internet Explorer</a></li>
                <li><a href="https://support.google.com/accounts/answer/61416?hl=de" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Google Chrome</a></li>
                <li><a href="https://www.opera.com/de/help" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Opera</a></li>
                <li><a href="https://support.apple.com/kb/PH17191?locale=de_DE&viewlocale=de_DE" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">Safari</a></li>
              </ul>
            </section>

            {/* Google Analytics */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Verwendung von Google Analytics</h2>
              <h3 className="font-serif text-xl text-white mb-2">Art und Zweck der Verarbeitung:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Diese Website benutzt Google Analytics, einen Webanalysedienst der Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043 USA (nachfolgend: „Google"). Google Analytics verwendet sog. „Cookies", also Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Webseite durch Sie ermöglichen.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Webseite werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf diesen Webseiten, wird Ihre IP-Adresse von Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt.
              </p>
              <h3 className="font-serif text-xl text-white mt-4 mb-2">Rechtsgrundlage:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Die Verarbeitung der Daten erfolgt auf Grundlage einer Einwilligung des Nutzers (Art. 6 Abs. 1 lit. a DSGVO).
              </p>
              <h3 className="font-serif text-xl text-white mt-4 mb-2">Widerruf der Einwilligung:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Webseite bezogenen Daten an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und installieren: Browser Add On zur Deaktivierung von Google Analytics.
              </p>
            </section>

            {/* Google Web Fonts */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Verwendung von Scriptbibliotheken (Google Webfonts)</h2>
              <p className="text-[#A0A0A0] mb-4">
                Um unsere Inhalte browserübergreifend korrekt und grafisch ansprechend darzustellen, verwenden wir auf dieser Website „Google Web Fonts" der Google LLC (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; nachfolgend „Google") zur Darstellung von Schriften.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Die Datenschutzrichtlinie des Bibliothekbetreibers Google finden Sie hier:{' '}
                <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">
                  www.google.com/policies/privacy/
                </a>
              </p>
            </section>

            {/* Google Maps */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Verwendung von Google Maps</h2>
              <p className="text-[#A0A0A0] mb-4">
                Auf dieser Webseite nutzen wir das Angebot von Google Maps. Google Maps wird von Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA (nachfolgend „Google") betrieben. Dadurch können wir Ihnen interaktive Karten direkt in der Webseite anzeigen und ermöglichen Ihnen die komfortable Nutzung der Karten-Funktion.
              </p>
              <h3 className="font-serif text-xl text-white mt-4 mb-2">Rechtsgrundlage:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Rechtsgrundlage für die Einbindung von Google Maps und dem damit verbundenen Datentransfer zu Google ist Ihre Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
              </p>
              <h3 className="font-serif text-xl text-white mt-4 mb-2">Widerruf der Einwilligung:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Wenn Sie nicht möchten, dass Google über unseren Internetauftritt Daten über Sie erhebt, verarbeitet oder nutzt, können Sie in Ihrem Browsereinstellungen JavaScript deaktivieren. In diesem Fall können Sie unsere Webseite jedoch nicht oder nur eingeschränkt nutzen.
              </p>
            </section>

            {/* YouTube Videos */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Eingebettete YouTube-Videos</h2>
              <p className="text-[#A0A0A0] mb-4">
                Auf einigen unserer Webseiten betten wir YouTube-Videos ein. Betreiber der entsprechenden Plugins ist die YouTube, LLC, 901 Cherry Ave., San Bruno, CA 94066, USA (nachfolgend „YouTube"). Wenn Sie eine Seite mit dem YouTube-Plugin besuchen, wird eine Verbindung zu Servern von YouTube hergestellt.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Wird ein YouTube-Video gestartet, setzt der Anbieter Cookies ein, die Hinweise über das Nutzerverhalten sammeln.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Weitere Informationen zu Zweck und Umfang der Datenerhebung und ihrer Verarbeitung durch YouTube erhalten Sie in den Datenschutzerklärungen des Anbieters:{' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">
                  policies.google.com/privacy
                </a>
              </p>
            </section>

            {/* Social Plugins */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Social Plugins</h2>
              <p className="text-[#A0A0A0] mb-4">
                Auf unseren Webseiten werden Social Plugins der unten aufgeführten Anbieter eingesetzt. Die Plugins können Sie daran erkennen, dass sie mit dem entsprechenden Logo gekennzeichnet sind.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Über diese Plugins werden unter Umständen Informationen, zu denen auch personenbezogene Daten gehören können, an den Dienstebetreiber gesendet und ggf. von diesem genutzt. Wir verhindern die unbewusste und ungewollte Erfassung und Übertragung von Daten an den Diensteanbieter durch eine 2-Klick-Lösung.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Wir haben auf unserer Website die Social-Media-Buttons folgender Unternehmen eingebunden: <strong className="text-white">Instagram, Facebook, TikTok</strong>
              </p>
            </section>

            {/* Google AdWords */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Google AdWords</h2>
              <p className="text-[#A0A0A0] mb-4">
                Unsere Webseite nutzt das Google Conversion-Tracking. Betreibergesellschaft der Dienste von Google AdWords ist die Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. Sind Sie über eine von Google geschaltete Anzeige auf unsere Webseite gelangt, wird von Google Adwords ein Cookie auf Ihrem Rechner gesetzt.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Diese Cookies verlieren nach 30 Tagen ihre Gültigkeit und dienen nicht der persönlichen Identifizierung.
              </p>
              <h3 className="font-serif text-xl text-white mt-4 mb-2">Widerruf der Einwilligung:</h3>
              <p className="text-[#A0A0A0] mb-4">
                Möchten Sie nicht am Tracking teilnehmen, können Sie das hierfür erforderliche Setzen eines Cookies ablehnen – etwa per Browser-Einstellung, die das automatische Setzen von Cookies generell deaktiviert oder Ihren Browser so einstellen, dass Cookies von der Domain „googleleadservices.com" blockiert werden.
              </p>
            </section>

            {/* Google Remarketing */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Einsatz von Google Remarketing</h2>
              <p className="text-[#A0A0A0] mb-4">
                Diese Webseite verwendet die Remarketing-Funktion der Google Inc. Die Funktion dient dazu, Webseitenbesuchern innerhalb des Google-Werbenetzwerks interessenbezogene Werbeanzeigen zu präsentieren.
              </p>
              <p className="text-[#A0A0A0] mb-4">
                Sollten Sie die Funktion Remarketing von Google nicht wünschen, können Sie diese grundsätzlich deaktivieren, indem Sie die entsprechenden Einstellungen unter{' '}
                <a href="https://support.google.com/adwordspolicy/answer/143465" target="_blank" rel="noopener noreferrer" className="text-white hover:underline">
                  support.google.com/adwordspolicy/answer/143465
                </a>{' '}
                vornehmen.
              </p>
            </section>

            {/* SSL */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">SSL-Verschlüsselung</h2>
              <p className="text-[#A0A0A0] mb-4">
                Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.
              </p>
            </section>

            {/* Änderungen */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Änderung unserer Datenschutzbestimmungen</h2>
              <p className="text-[#A0A0A0] mb-4">
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen, z.B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
            </section>

            {/* Kontakt */}
            <section>
              <h2 className="font-serif text-2xl text-white mb-4">Fragen an den Datenschutzbeauftragten</h2>
              <p className="text-[#A0A0A0] mb-4">
                Wenn Sie Fragen zum Datenschutz haben, schreiben Sie uns bitte eine E-Mail oder wenden Sie sich direkt an die für den Datenschutz verantwortliche Person in unserer Organisation:
              </p>
              <p className="text-[#A0A0A0]">
                E-Mail: <a href="mailto:tattoo-kryptonite@gmx.de" className="text-white hover:underline">tattoo-kryptonite@gmx.de</a>
              </p>
            </section>

            <p className="text-[#A0A0A0] text-sm mt-12 pt-8 border-t border-white/10">
              Die Datenschutzerklärung wurde mithilfe der activeMind AG erstellt, den Experten für externe Datenschutzbeauftragte (Version #2019-04-10).
            </p>
          </div>
          <div className="mt-12">
            <Link to="/" className="text-[#A0A0A0] hover:text-white transition-colors">
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

// FAQ Page - All categories
const FAQPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation />
      <div className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="text-center mb-16">
            <p className="text-xs uppercase tracking-[0.2em] text-white/50 mb-4">Häufige Fragen</p>
            <h1 className="font-serif text-4xl md:text-5xl text-white">FAQs</h1>
            <p className="mt-4 text-[#A0A0A0]">Alles was du vor deinem Tattoo wissen solltest</p>
          </div>

          <div className="space-y-12">
            {faqCategories.map((category, catIndex) => (
              <div key={catIndex} data-testid={`faq-category-${catIndex}`}>
                <h2 className="text-lg font-medium text-white mb-6 pb-2 border-b border-white/20">
                  {category.category}
                </h2>
                <Accordion type="single" collapsible className="space-y-2">
                  {category.faqs.map((faq, index) => (
                    <AccordionItem
                      key={index}
                      value={`cat-${catIndex}-item-${index}`}
                      className="border border-white/10 bg-[#0a0a0a] px-6"
                    >
                      <AccordionTrigger className="text-left text-white hover:text-white/80 py-5 text-base">
                        {faq.question}
                      </AccordionTrigger>
                      <AccordionContent className="text-[#A0A0A0] pb-5 leading-relaxed">
                        {faq.answer}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            ))}
          </div>

          {/* WhatsApp CTA */}
          <div className="mt-16 text-center">
            <p className="text-[#A0A0A0] mb-4">Noch Fragen? Schreib uns einfach!</p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 hover:bg-[#20bd5a] transition-colors"
            >
              <WhatsappLogo size={20} weight="fill" />
              <span className="font-medium">WhatsApp</span>
            </a>
          </div>

          <div className="mt-12">
            <Link to="/" className="text-[#A0A0A0] hover:text-white transition-colors">
              ← Zurück zur Startseite
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

// Main App
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/dsgvo" element={<DSGVOPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
